module.exports = __webpack_public_path__ + "img/ylands_join_ad_copy.4c32a402.png";